<template>
</template>
<script>
export default {
    name: 'VistaBlank',
    data () {
      return {             
      }
    },
    methods:{                
        
    },
    watch:{
        
    },
    computed: {  
        
    },
    components: {
        
    }
}
</script>